export class Cadastro {
  nome_servidor: string;
  endereco: string;
  cpf: string;
  telefone: string;
  telefone_secundario: string;
  orgao_id: number;
  matricula: string;
  matricula_dois: string;
  cargo: string;
  cidade_id: number;
  tipo_solicitante_id: number;
  email: string;
  email_secundario: string;

 public Cadastro() {
    this.nome_servidor = '';
    this.endereco = '';
    this.cpf = '';
    this.matricula = '';
    this.matricula_dois = '';
    this.cargo = '';
    this.telefone = '';
    this.telefone_secundario = '';
    this.orgao_id = 0;
    this.cidade_id = 0;
    this.tipo_solicitante_id = 0;
    this.email = '';
    this.email_secundario = '';
  }
}
